import React from 'react';
import { connect } from 'react-redux';

import './BreakdownTabs.css';
import { penceToPounds } from '../../utils/currency';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import AccountItem from '../../components/AccountItem/AccountItem';
import GroupNameHeader from '../../components/GroupNameHeader/GroupNameHeader';
import { ASSETS_TYPE, LIABILITIES_TYPE } from '../../utils/templateHistoryTypes';
import { updateGroupName } from '../../actions/history-actions'

import {
  createAccount,
  updateAccount,
  deleteAccount,
  createGroup,
  updateGroup,
  deleteGroup,

} from '../../actions/history-actions';

class BreakdownTabs extends React.Component {

  constructor(props) {
    super(props)
    this.handleCreateAccount = this.handleCreateAccount.bind(this)
    this.handleUpdateAccount = this.handleUpdateAccount.bind(this)
    this.handleDeleteAccount = this.handleDeleteAccount.bind(this)

    this.handleCreateGroup = this.handleCreateGroup.bind(this)
    this.handleUpdateGroup = this.handleUpdateGroup.bind(this)
    this.handleDeleteGroup = this.handleDeleteGroup.bind(this)

    this.handleGroupNameSubmit = this.handleGroupNameSubmit.bind(this)
  }

  handleCreateAccount(groupId) {
    const { dispatch } = this.props
    dispatch(createAccount(groupId))
  }

  handleUpdateAccount(groupId, updatedAccount) {
    const { dispatch } = this.props
    dispatch(updateAccount(groupId, updatedAccount))
  }

  handleDeleteAccount(groupId, accountId) {
    const { dispatch } = this.props
    dispatch(deleteAccount(groupId, accountId))
  }

  handleCreateGroup(groupType) {
    const { dispatch } = this.props;
    dispatch(createGroup(groupType));
  }

  handleUpdateGroup(groupId, updatedGroup) {
    const { dispatch } = this.props;
    dispatch(updateGroup(groupId, updatedGroup));
  }

  handleDeleteGroup(groupId, groupType) {
    const { dispatch } = this.props;
    if (window.confirm('Are you sure?')) {
      dispatch(deleteGroup(groupId, groupType));
    }
  }

  handleGroupNameSubmit(groupId, groupName) {
    console.log('handleGroupNameSubmit', groupId, groupName)
    const { dispatch } = this.props;
    dispatch(updateGroupName(groupId, groupName))
  }

  renderGroup(assets, groupType) {
    return (
      <div className="account-list-wrapper">
        <ul className="account-list assets-group-list">
          {assets.map((group, index) => {
            return (
              <li key={group._id} className="account-list__item assets-group-list__item">

                <div className="cell">
                  <GroupNameHeader
                    groupId={group._id}
                    groupName={group.groupName}
                    balance={penceToPounds(group.balance)}
                    handleGroupNameSubmit={this.handleGroupNameSubmit}
                    showDeleteButton={group.accounts.length === 0}
                    handleDeleteGroup={() => this.handleDeleteGroup(group._id, groupType)}
                  />
                </div>

                <div className="cell cell--big">
                  <div className="panel">
                    <div className="panel__inner">
                      <ul className="assets-group-list">
                        {group.accounts.map((account, index) => {
                          return (
                            <div>
                              <AccountItem
                                key={account._id}
                                account={account}
                                groupId={group._id}
                                isUpdating={this.props.isUpdating}
                                handleUpdateAccount={this.handleUpdateAccount}
                                handleDeleteAccount={this.handleDeleteAccount}
                            />
                            </div>
                          )
                        })}
                        <button className="btn btn-success" onClick={() => this.handleCreateAccount(group._id)}>Add New Asset</button>
                      </ul>
                    </div>
                  </div>
                </div>

              </li>
            )
          })}
        </ul>
        <button className="btn btn-success add-group" onClick={() => this.handleCreateGroup(groupType)}>Add New Group</button>
      </div>
    )
  }

  render() {
    return (
      <section className="breakdown-tabs">
        <div className="container breakdown--container">

          <h2>
            Assets
        </h2>
        <p>
        An Asset can be anything that you own. Like a car or shares in a company.
        You can put assets under helpful groups like "Cash and Bank Accounts", "Investments" or "Other Assets".
        You can edit the group name. Delete a group, or, add a new group by clicking the <strong className="text-success">Add New Group</strong> button.
        </p>

          <div className="breakdown-tabs__inner">

            <div className="group">


              {this.renderGroup(this.props.assets, ASSETS_TYPE)}

            </div>

            <div className="group">
              <h2>Liabilities</h2>
              <p>
              A Liability is everything that you owe. This could be a something like a student loan or mortgage.
        </p>
              {this.renderGroup(this.props.liabilities, LIABILITIES_TYPE)}
            </div>

          </div>
        </div>
      </section>
    )
  }
}

const mapStateToProps = (state) => ({
  history: state.history.history,
  currentHistoryIndex: state.history.currentHistoryIndex,
  isUpdating: state.history.isUpdating
});

export default connect(mapStateToProps)(BreakdownTabs);



// WEBPACK FOOTER //
// ./src/containers/BreakdownTabs/BreakdownTabs.js